import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { KOSTEN_ARTEN, KOSTEN_POSITION, KOSTENTRAEGER } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { enumT } from 'src/utils/helper';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragBescheidGlobal } from '../../global-structure/antrag-bescheid/TreestructureAntragBescheidGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureAntragVorzeitigerMassnahme } from '../../global-structure/vorzeitige-massnahme/TreeStructureVorzeitigeMassnahmeGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import AntragAufProjektFoerderungAntragKreativwirtschaft from './content/antrag-auf-projektfoerderung/AntragAufProjektFoerderungAntragKreativwirtschaft';
import NachweisEffektivitaetEffizienzAntragKreativwirtschaft, {
	getFormStrucNachweisEffektivitaetEffizienzAntragKreativwirtschaft,
} from './content/antrag-auf-projektfoerderung/children/NachweisEffektivitaetEffizienz';
import ProjektBeschreibungAntragKreativwirtschaft, {
	getFormStrucProjektBeschreibungAntragKreativwirtschaft,
} from './content/antrag-auf-projektfoerderung/children/ProjektBeschreibungAntragKreativwirtschaft';
import ProjektDurchfuehrungAntragKreativwirtschaft, {
	getFormStrucProjektDurchfuehrungAntragKreativwirtschaft,
} from './content/antrag-auf-projektfoerderung/children/ProjektDurchfuehrungAntragKreativwirtschaft';
import EinnahmenAntragKreativwirtschaft, { getFormStrucEinnahmenAntragKreativwirtschaft } from './content/Einnahmen/EinnahmenAntragKreativwirtschaft';
import EinnahmenUebersichtAntragKreativwirtschaft from './content/Einnahmen/EinnahmenUebersichtAntragKreativwirtschaft';
import FinanzierungsplanKreativ, { getFormStrucFinanzierungsplanKreativ } from './content/finanzierungsplan/FinanzierungsplanKreativ';
import PersonalkostenAntragKreativwirtschaft, {
	getFormStrucPersonalkostenAntragKreativwirtschaft,
} from './content/personalkosten/PersonalkostenAntragKreativwirtschaft';
import PersonalkostenAntragKreativwirtschaftUebersicht from './content/personalkosten/PersonalkostenAntragKreativwirtschaftUebersicht';
import ProjektDatenAntragKreativwirtschaft, { getFormStrucProjektDatenAntragKreativwirtschaft } from './content/ProjektDatenAntragKreativwirtschaft';
import SachkostenAntragKreativwirtschaft, {
	getFormStrucSachkostenAntragKreativwirtschaft,
} from './content/sachkosten/SachkostenAntragKreativwirtschaft';
import SachkostenAntragKreativwirtschaftUebersicht from './content/sachkosten/SachkostenAntragKreativwirtschaftUebersicht';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
const P = AntragSchema.attributes;

export const TreeStructureAntragKreativwirtschaft = (
	application: any,
	readOnly: boolean,
	kostenKategories: any[],
	kostenKategoriesGroup: any,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
) => {
	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);

	let treeNodes: TreeNodeType[] = [
		// Allgemeine Hinweis Global
		...TreeStructureAllgemeinHinweisGlobal(application),
		// Projektdaten
		{
			label: 'Projektdaten',
			content: <ProjektDatenAntragKreativwirtschaft hasComment={hasCommentProjektdaten} />,
			formStruc: getFormStrucProjektDatenAntragKreativwirtschaft(application),
			hasComment: hasCommentProjektdaten,
		},
		// Antragsteller Global
		...TreeStructureAntragstellerGlobal(application, readOnly),
		// Selbsterlärung-KMU Global
		...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
		// Beihilferelevanz-Erklärungen Global
		...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
		// RUS-Erklärungen Global
		...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
		// Deminismis-Selbsterklärung Global
		...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
		// Projektbeschreibung
		...ProjektbeschreibungStructure(application, readOnly),
		// Kosten
		...PersonalKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...SachKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...EinnahmeStructure(application, kostenKategories, kostenKategoriesGroup, readOnly, isKostenEditable),
		// Finanzierungsplan Global
		{
			label: 'Ausgaben- und Finanzierungsplan',
			content: <FinanzierungsplanKreativ />,
			formStruc: getFormStrucFinanzierungsplanKreativ(application),
			hasComment: isKostenEditable,
			isSummaryReport: true,
		},
		// Zeitplanung Global
		...TreeStructureZeitplanungGlobal(application, readOnly),
		// Anlgen und Erklärung Global
		...TreeStructureAnlagenGlobal(application, readOnly),
		...TreeStructureErklaerungGlobal(application, readOnly),
		// Vorzeitiger Massnahme Global
		...TreeStructureAntragVorzeitigerMassnahme(application, readOnly),
		// Abschlussseite Global
		...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
		// Bescheid Global
		...TreeStructureAntragBescheidGlobal(application),
	];

	return treeNodes;
};

const ProjektbeschreibungStructure = (application: any, readOnly: boolean) => {
	const hasCommentProjektbeschreibung = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektbeschreibung_Pruefstatus.path,
	);
	const hasCommentProjektdurchfuehrung = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Projektdurchfuehrung_Pruefstatus.path,
	);
	const hasCommentEffizienz = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Pruefstatus.path,
	);

	let nodes: TreeNodeType[] = [
		{
			label: 'Projektbeschreibung',
			content: <AntragAufProjektFoerderungAntragKreativwirtschaft />,
			hasComment: hasCommentProjektbeschreibung || hasCommentProjektdurchfuehrung || hasCommentEffizienz ? true : false,
			children: [
				{
					label: 'Projektbeschreibung',
					content: <ProjektBeschreibungAntragKreativwirtschaft hasComment={hasCommentProjektbeschreibung} />,
					formStruc: getFormStrucProjektBeschreibungAntragKreativwirtschaft(application),
					hasComment: hasCommentProjektbeschreibung,
				},
				{
					label: 'Projektdurchführung',
					content: <ProjektDurchfuehrungAntragKreativwirtschaft hasComment={hasCommentProjektdurchfuehrung} />,
					formStruc: getFormStrucProjektDurchfuehrungAntragKreativwirtschaft(application),
					hasComment: hasCommentProjektdurchfuehrung,
				},
				{
					label: 'Erfolgskontrolle',
					content: <NachweisEffektivitaetEffizienzAntragKreativwirtschaft hasComment={hasCommentEffizienz} />,
					formStruc: getFormStrucNachweisEffektivitaetEffizienzAntragKreativwirtschaft(application),
					hasComment: hasCommentEffizienz,
				},
			],
		},
	];
	return nodes;
};
const PersonalKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
		nodes = [
			{
				label: enumT(KOSTEN_ARTEN.Personalkosten),
				content: (
					<PersonalkostenAntragKreativwirtschaft
						kostentraeger={KOSTENTRAEGER.Antragsteller}
						unternehmenId={get(getLocalstorageToken(), 'organisationId')}
						hasComment={hasCommentAusgabenUndFinanzierung}
					/>
				),
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Personalkosten),
				formStruc: getFormStrucPersonalkostenAntragKreativwirtschaft(application, get(getLocalstorageToken(), 'organisationId')),
			},
			{
				label: `${enumT(KOSTEN_ARTEN.Personalkosten)} Übersicht`,
				content: <PersonalkostenAntragKreativwirtschaftUebersicht />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const SachKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)) {
		nodes = [
			{
				label: enumT(KOSTEN_ARTEN.Sachkosten),
				content: (
					<SachkostenAntragKreativwirtschaft
						kostentraeger={KOSTENTRAEGER.Antragsteller}
						unternehmenId={get(getLocalstorageToken(), 'organisationId')}
						hasComment={hasCommentAusgabenUndFinanzierung}
					/>
				),
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Sachkosten),
				formStruc: getFormStrucSachkostenAntragKreativwirtschaft(application, get(getLocalstorageToken(), 'organisationId')),
			},
			{
				label: `${enumT(KOSTEN_ARTEN.Sachkosten)} Übersicht`,
				content: <SachkostenAntragKreativwirtschaftUebersicht />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const EinnahmeStructure = (
	application: any,
	kostenKategories: any[],
	kostenKategoriesGroup: any,
	readOnly: boolean,
	hasCommentAusgabenUndFinanzierung?: boolean,
) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
		nodes = [
			{
				label: enumT(KOSTEN_ARTEN.Eigenmittel),
				content: (
					<EinnahmenAntragKreativwirtschaft
						kostentraeger={KOSTENTRAEGER.Antragsteller}
						unternehmenId={get(getLocalstorageToken(), 'organisationId')}
						hasComment={hasCommentAusgabenUndFinanzierung}
					/>
				),
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
				formStruc: getFormStrucEinnahmenAntragKreativwirtschaft(application, kostenKategories, get(getLocalstorageToken(), 'organisationId')),
			},
			{
				label: `${enumT(KOSTEN_ARTEN.Eigenmittel)} Übersicht`,
				content: <EinnahmenUebersichtAntragKreativwirtschaft />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
